function Home() {
    return (
        <section id="banner">
        <div class="inner">
          <h2>Open now!</h2>
          <p>Here at Pause Hair Salon, it is my pleasure to provide my clients, neighbours and friends with high quality service, including great attention to detail.</p>
          <p>Enter into this clean and relaxing environment and simply, pause.</p>
          <ul class="actions">
            <li><a href="services" class="button alt scrolly big">Services</a></li>
            <li><a href="#contact" class="button alt scrolly big">Contact</a></li>
          </ul>
        </div>
      </section>
    );
}

export default Home;